<template>
    <v-container class="pb-6">
        <module-form
            :module="this.module"
            @saved="saved"
            :titlePrefix="$t('form.actions.edit')"
            :isEdit="true"
            v-if="this.module"
        ></module-form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import Module from '@/models/plans/Module'
import Form from './Form'

export default {
    props: ['id'],

    data: () => {
        return {
            module: null,
        }
    },

    components: {
        'module-form': Form,
    },

    methods: {
        async getModule() {
            let item = await this.model.find(this.id)

            this.module = item
        },

        saved() {
            this.$router.push({ name: 'modules.index' })
        },
    },

    computed: {
        model() {
            return new Module()
        },
    },

    created() {
        this.getModule()
    },
}
</script>
